export { default as Divider } from "./Divider/Divider";
export { default as Header } from "./Header/Header";
export { default as Prices } from "./Prices/Prices";
export { default as BookingRating } from "./BookingRating/BookingRating";
export { default as Rooms } from "./Rooms/Rooms";
export { default as Notes } from "./Notes/Notes";
export { default as Dates } from "./Dates/Dates";
export { default as Cart } from "./Cart";



// WEBPACK FOOTER //
// ./src/components/Cart/index.js